import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 39,
	height: 30,
	viewBox: "0 0 39 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5244 14.5455V0H32.3483C33.4184 0 34.3109 0.158617 35.0258 0.475852C35.7408 0.793087 36.2782 1.23343 36.6381 1.79688C36.9979 2.35559 37.1778 2.99953 37.1778 3.72869C37.1778 4.29688 37.0642 4.7964 36.8369 5.22727C36.6096 5.65341 36.2971 6.00379 35.8994 6.27841C35.5064 6.5483 35.0566 6.74006 34.55 6.85369V6.99574C35.104 7.01941 35.6224 7.17566 36.1054 7.46449C36.5931 7.75331 36.9884 8.15814 37.2915 8.67898C37.5945 9.19508 37.746 9.81061 37.746 10.5256C37.746 11.2973 37.5542 11.9863 37.1707 12.5923C36.7919 13.1937 36.2309 13.6695 35.4875 14.0199C34.7441 14.3703 33.8279 14.5455 32.7389 14.5455H26.5244ZM29.5997 12.0312H32.1068C32.9638 12.0312 33.5888 11.8679 33.9818 11.5412C34.3748 11.2098 34.5713 10.7694 34.5713 10.2202C34.5713 9.81771 34.4742 9.46259 34.2801 9.15483C34.086 8.84706 33.809 8.60559 33.4491 8.4304C33.094 8.25521 32.6702 8.16761 32.1778 8.16761H29.5997V12.0312ZM29.5997 6.08665H31.8795C32.3009 6.08665 32.675 6.01326 33.0017 5.86648C33.3331 5.71496 33.5935 5.50189 33.7829 5.22727C33.9771 4.95265 34.0741 4.62358 34.0741 4.24006C34.0741 3.71449 33.8871 3.29072 33.5131 2.96875C33.1437 2.64678 32.6182 2.4858 31.9363 2.4858H29.5997V6.08665Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.29545 29.9996H0L5.02131 15.4541H8.98438L13.9986 29.9996H10.7031L7.05966 18.778H6.94602L3.29545 29.9996ZM3.08949 24.2822H10.8736V26.6828H3.08949V24.2822Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.02441 0L38.0244 29.7394H35.0244L0.0244141 0H3.02441Z",
			fill: "currentColor"
		})
	]
});
export default SvgCompare;
